export const comments_3257605 = {"data":{"data":[],"links":{}}}